<template>
  <Page title="Warranties" subpage>
    <template #actions>
      <div class="d-flex align-items-end flex-wrap gap-3">
        <ToggleSwitch
          v-model="active"
          label-on="Active"
          label-off="All"
          class="mr-3"
        />
        <Select
          v-model="equipmentTypeIds"
          class="mr-3"
          :options="equipmentTypeOptions"
          label="Equipment Types"
          multiple
          search
          close-on-multi-select
        />
        <Button
          icon="far fa-plus"
          text="Add Warranty"
          @click="handleNewWarranty"
        ></Button>
      </div>
    </template>
    <WarrantyProgramsList
      :equipment-type-ids="equipmentTypeIds"
      :active="active"
    />
  </Page>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { getQueryVariables, updateQueryParam } from "@/lib/url.js";

import Button from "@/components/Button.vue";
import Page from "@/components/Page.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import { sortEquipmentTypes } from "@/vuex/modules/equipmentTypes";
import WarrantyProgramsList from "./WarrantyProgramsList.vue";

export default {
  components: {
    Page,
    Button,
    ToggleSwitch,
    WarrantyProgramsList
  },
  data() {
    return {
      equipmentTypeIds: null,
      active: true
    };
  },
  computed: {
    ...mapState({
      equipmentTypeOptions({ equipmentTypes }) {
        return sortEquipmentTypes(equipmentTypes).map((equipmentType) => ({
          value: equipmentType.id,
          label: equipmentType.name
        }));
      }
    })
  },
  watch: {
    equipmentTypeIds(val) {
      updateQueryParam("equipment_type_id", val, true);
    }
  },
  created() {
    const { equipment_type_id } = getQueryVariables();
    this.fetchEquipmentTypes();
    if (equipment_type_id) {
      this.equipmentTypeIds = equipment_type_id
        .split(",")
        .map((val) => parseInt(val));
    }
  },
  methods: {
    ...mapActions(["fetchEquipmentTypes", "clearCurrentWarrantyProgram"]),
    handleNewWarranty() {
      this.clearCurrentWarrantyProgram();
      this.$router.push(this.warrantyProgramNewPath());
    }
  }
};
</script>

<style lang="scss" scoped></style>
